module.exports = __webpack_public_path__ + "static/media/close-img.29ea0dae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-img.svg
// module id = 1395
// module chunks = 1